module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      started: _vm.isSetup,
        fit: _vm.isFit,
        number: _vm.isNumber
    },
    attrs: {
      "id": "app"
    },
    on: {
      "click": _vm.click
    }
  }, [_c('div', {
    ref: "stage",
    attrs: {
      "id": "stage"
    }
  }, [_c('div', {
    attrs: {
      "id": "display"
    }
  }, [_c('div', {
    ref: "winners",
    attrs: {
      "id": "winners"
    }
  }, _vm._l((_vm.winners), function(winner, i) {
    return _c('name-label', {
      key: i,
      attrs: {
        "name": winner.name,
        "desc": winner.desc
      }
    })
  }), 1), _vm._v(" "), _c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.winners.length && _vm.isFit),
      expression: "!winners.length && isFit"
    }],
    ref: "welcome",
    attrs: {
      "id": "welcome",
      "contenteditable": _vm.editing,
      "spellcheck": "false"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.welcome)
    },
    on: {
      "dblclick": function($event) {
        $event.stopPropagation();
        return _vm.edit(true)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.edit(false)
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control"
    }
  }, [_c('form', {
    attrs: {
      "id": "setup"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.setup($event)
      }
    }
  }, [(_vm.mode !== 'number') ? _c('label', [_c('file', {
    ref: "upload",
    attrs: {
      "disabled": _vm.isSetup
    },
    on: {
      "change": _vm.upload
    }
  }, [_vm._v("选择文件")])], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 'both') ? _c('span', {
    staticClass: "separator"
  }, [_vm._v("- or -")]) : _vm._e(), _vm._v(" "), (_vm.mode !== 'import') ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.total),
      expression: "total",
      modifiers: {
        "number": true
      }
    }],
    ref: "total",
    attrs: {
      "type": "number",
      "required": "",
      "min": "1",
      "max": "999",
      "disabled": _vm.isSetup,
      "placeholder": "一共有几人？"
    },
    domProps: {
      "value": (_vm.total)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.total = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mode !== 'import') ? _c('button', {
    attrs: {
      "disabled": _vm.isSetup
    }
  }, [_vm._v("确定")]) : _vm._e()]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "roll"
    },
    on: {
      "reset": _vm.reset,
      "submit": function($event) {
        $event.preventDefault();
        return _vm.roll($event)
      }
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.round),
      expression: "round",
      modifiers: {
        "number": true
      }
    }],
    ref: "round",
    attrs: {
      "type": "number",
      "required": "",
      "disabled": !_vm.isSetup || _vm.rolling,
      "min": "1",
      "max": _vm.remaining || 50,
      "placeholder": "本轮抽几人？"
    },
    domProps: {
      "value": (_vm.round)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.round = _vm._n($event.target.value)
      }, _vm.checkRemaining],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v("\n        /\n        "), _c('span', {
    staticClass: "remaining"
  }, [_vm._v(_vm._s(_vm.remaining))]), _vm._v(" "), _c('button', {
    ref: "begin",
    attrs: {
      "disabled": !_vm.isSetup || _vm.coolingDown,
      "name": "begin"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.rolling ? '停止' : '开始') + "\n          "), (_vm.coolingDown) ? _c('span', {
    staticClass: "cooler",
    style: (("animation-duration: " + _vm.cooldown + "ms;"))
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "reset",
      "disabled": !_vm.isSetup || _vm.coolingDown
    }
  }, [_vm._v("\n          重置\n          "), (_vm.coolingDown) ? _c('span', {
    staticClass: "cooler",
    style: (("animation-duration: " + _vm.cooldown + "ms;"))
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openLog
    }
  }, [_vm._v("记录")])])])]), _vm._v(" "), _c('div', {
    class: {
      show: _vm.showLog, modal: true
    },
    attrs: {
      "id": "log",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        _vm.showLog = false
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.showSettings = false
      }
    }
  }, [_c('h2', [_vm._v("抽取历史")]), _vm._v(" "), (_vm.logs.length) ? _c('ol', _vm._l((_vm.logs), function(log, i) {
    return _c('li', {
      key: i
    }, _vm._l((log), function(winner, j) {
      return _c('name-label', {
        key: j,
        attrs: {
          "name": winner.name,
          "desc": winner.desc
        }
      })
    }), 1)
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.logs.length) ? _c('h2', {
    staticClass: "empty"
  }, [_vm._v("还没有进行过抽奖")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      show: _vm.showSettings, modal: true
    },
    attrs: {
      "id": "settings",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showSettings = false
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.showSettings = false
      }
    }
  }, [_c('h2', [_vm._v("设置")]), _vm._v(" "), _c('form', [_c('p', [_c('label', [_c('span', {
    staticClass: "label"
  }, [_vm._v("间隔时间")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.cooldown),
      expression: "cooldown",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cooldown)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cooldown = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _c('span', {
    staticClass: "tip"
  }, [_vm._v("毫秒")])])]), _vm._v(" "), _c('p', [_c('label', [_c('span', {
    staticClass: "label"
  }, [_vm._v("表情")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emojis),
      expression: "emojis"
    }],
    staticClass: "hero",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.emojis)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emojis = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "label"
  }, [_vm._v("输入模式")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mode),
      expression: "mode"
    }],
    attrs: {
      "type": "radio",
      "value": "import"
    },
    domProps: {
      "checked": _vm._q(_vm.mode, "import")
    },
    on: {
      "change": function($event) {
        _vm.mode = "import"
      }
    }
  }), _c('span', [_vm._v("文件导入")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mode),
      expression: "mode"
    }],
    attrs: {
      "type": "radio",
      "value": "number"
    },
    domProps: {
      "checked": _vm._q(_vm.mode, "number")
    },
    on: {
      "change": function($event) {
        _vm.mode = "number"
      }
    }
  }), _c('span', [_vm._v("抽取序号")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mode),
      expression: "mode"
    }],
    attrs: {
      "type": "radio",
      "value": "both"
    },
    domProps: {
      "checked": _vm._q(_vm.mode, "both")
    },
    on: {
      "change": function($event) {
        _vm.mode = "both"
      }
    }
  }), _c('span', [_vm._v("自由选择")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "custom"
    }
  }, [_c('label', [_c('span', {
    staticClass: "label"
  }, [_vm._v("自定义样式")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom),
      expression: "custom"
    }],
    attrs: {
      "spellcheck": "false",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.custom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custom = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "setting"
    },
    on: {
      "click": function($event) {
        _vm.showSettings = !_vm.showSettings
      }
    }
  }, [_c('octicon', {
    attrs: {
      "name": "gear"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "id": "github",
      "href": "https://github.com/Justineo/lucky"
    }
  }, [_c('octicon', {
    attrs: {
      "name": "mark-github",
      "label": "View on GitHub",
      "title": "View on GitHub"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13909d11!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 101
// module chunks = 2